import LoadingScreen from "../components/LoadingScreen";
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../components/AuthContext";

const FeatureRouteProtection = ({ children, feature, permission }) => {
  const { user, loading, hasFeature, hasPermission } = useContext(AuthContext);

  if (loading) return <LoadingScreen label="Checking session…" fullScreen />;

  // 🔐 NOT LOGGED IN
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // ❌ Not allowed
  if ((feature && !hasFeature(feature)) || (permission && !hasPermission(permission))) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default FeatureRouteProtection;
